<template lang="pug">
    .component-tabs
        ul.tabs(:id="id", data-tabs='', :data-deep-link="deepLink", :data-update-history="deepLink", :data-deep-link-smudge="deepLink")
            li.tabs-title(v-for="(tab,index) in tabs", :class="{'is-active': index ===activeIndex}")
                a(:href="'#'+$toDashedString(tab)", :aria-selected="index === activeIndex") {{tab}}
        .tabs-content(:data-tabs-content='id')
            slot
</template>
<script type="text/babel">
    export default{
        name: "TabHeaders",
        components: {},
        data(){
            return {}
        },
        mounted() {
            $(this.$el).find('#' + this.id).foundation()
        },
        created(){
        },
        methods: {},
        props: {
            tabs: Array,
            id: String,
            activeIndex: Number,
            deepLink: Boolean
        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">
    .dropdown-placeholder
        cursor: pointer
</style>


// WEBPACK FOOTER //
// TabHeaders.vue?52d6aad5